import React from "react";
import { FaLinkedinIn } from "react-icons/fa";
import { SiGithub, SiGmail } from "react-icons/si";
import { contactImg } from "../../assets/index";
import { bannerImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-5 justify-center">
      <img
        className="w-full h-54 object-cover rounded-lg mb-2"
        src={bannerImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-1">
        <h3 className="text-3xl font-bold text-white">Vikas Mishra</h3>
        <p className="text-lg font-normal text-gray-400">
          Senior Frontend Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          "I build robust, efficient, and user-focused web solutions. A champion
          of Agile practices, I blend strong design principles, expertise in
          JavaScript and ReactJS, and a keen eye for UX enhancements to deliver
          seamless digital experiences. Proficient in modern web technologies
          and design patterns, I thrive on creating scalable, high-performance
          interfaces."
        </p>
        {/* <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+91 secret 🤫</span>
        </p> */}
        {/* <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">mihirc0111@gmail.com</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Github: <span className="text-lightText">https://github.com/mihirc0111</span>
        </p> */}
      </div>
      <div className="flex flex-col gap-0">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me on</h2>
        <div className="flex gap-4">
          <a
            href="https://github.com/VikasX"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="bannerIcon">
              <SiGithub />
            </span>
          </a>
          {/* <span className="bannerIcon">
          <a href="mailto:mihirc0111@gmail.com">
            <SiGmail /></a>
          </span> */}
          <a
            href="https://www.linkedin.com/in/vikasmishra07"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
